enum FormFieldType {
    Text = 0,
    Number = 1,
    MultiSelect = 2,
    Treeview = 3,
    TableSelect = 4,
    InfoText = 5
}

export default FormFieldType;